module.exports = __webpack_public_path__ + "static/open-sans-regular-33543c5cc5d88f5695dd08c87d280dfd.woff2";